import styled from "styled-components";
export const TradingListWrapper = styled.div`
  .search-wrapper {
    background-color: ${({ theme }) => theme.box};
    padding: 10px;
    padding-bottom: 20px;
    margin-top: 20px;
    border-radius: 10px;
    box-shadow: 0px 1px 10px #00000010;
    .filter-button {
      height: auto;
      margin-top: 32px;
      margin-right: 10px;
      @media (max-width: 768px) {
        font-size: 12px;
      }
    }
    .form-group {
      width: 70%;
    }
  }
  .filterButtons {
    .button {
      text-align: center;
      border-radius: 5px;
      padding: 20px 10px;
      &:hover {
        cursor: pointer;
      }
    }
    .button-inprogress {
      border: 1px solid #ffc107;
    }
    .button-failed {
      border: 1px solid #dc3847;
    }
    .button-success-offline {
      border: 1px solid #17a2b8;
    }
    .button-success-online {
      border: 1px solid #27a644;
    }
    .button-all-orders {
      border: 1px solid #027bff;
    }
  }
  .invoice {
    display: flex;
    align-items: center;
    padding: 20px;
    margin-top: 20px;
    background-color: ${({ theme }) => theme.box};
    &:nth-child(odd) {
      background-color: ${({ theme }) => theme.body};
    }
    box-shadow: ${({ theme }) => theme.shadow};
    border-radius: 10px;
    margin-bottom: 20px;
    .status {
      .icon {
        font-size: 52px;
      }
    }
    .main-content {
      padding: 0px 20px;
    }
    .price {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .actions {
      display: flex;

      justify-content: left;
      button {
        margin: 0px 5px;
        height: 30px;
        padding: 0px;
        width: 30px;
        svg {
          margin: 6px;
        }
      }
    }
  }
  @media (max-width: 768px) {
    .invoice {
      .status {
        display: flex;
        align-self: flex-start;
      }
      .main-content {
      }
    }
  }
`;
